import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Instagram, Github } from 'lucide-react';
import { useCMS } from '../context/CMSContext';

const COLUMNS = [
  {
    title: 'Services',
    items: [
      { label: 'Website Development', href: '/services' },
      { label: 'SEO Optimization', href: '/services' },
      { label: 'Branding', href: '/services' },
      { label: 'Digital Marketing', href: '/services' },
      { label: 'CRM Integrations', href: '/services' },
      { label: 'Lead Generation', href: '/services' },
    ],
  },
  {
    title: 'Industries',
    items: [
      { label: 'Dealerships', href: '/services' },
      { label: 'Rental Companies', href: '/services' },
      { label: 'Agricultural', href: '/services' },
      { label: 'Construction', href: '/services' },
      { label: 'Transport', href: '/services' },
    ],
  },
  {
    title: 'Company',
    items: [
      { label: 'Success Stories', href: '/our-work' },
      { label: 'Blog', href: '/blog' },
      { label: 'Contact Us', href: '/contact' },
    ],
  },
];

const SOCIALS = [
  { Icon: Linkedin, label: 'LinkedIn (placeholder)', href: '#' },
  { Icon: Twitter, label: 'Twitter (placeholder)', href: '#' },
  { Icon: Instagram, label: 'Instagram (placeholder)', href: '#' },
  { Icon: Github, label: 'GitHub (placeholder)', href: '#' },
];

const Footer = () => {
  const { get } = useCMS();
  const company = get('company_info') || {};
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-[#050914] border-t border-white/5" data-testid="site-footer">
      {/* Links */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Link to="/" className="inline-flex items-center gap-2">
            <img
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_digitize-pro-2/artifacts/bzn1ek7z_image.png"
              alt="Digitize Intl."
              className="h-24 w-auto object-contain brightness-0 invert -my-6"
              loading="lazy"
              decoding="async"
            />
          </Link>
          <p className="mt-5 text-white/50 text-sm font-light leading-relaxed max-w-xs">
            {company.description || 'Premium digital solutions for industrial and automotive brands.'}
          </p>
          <div className="mt-8 space-y-2">
            {company.phone && <p className="text-sm text-white/70">{company.phone}</p>}
            {company.email && <p className="text-sm text-white/70">{company.email}</p>}
            {company.address && <p className="text-sm text-white/70">{company.address}</p>}
          </div>
          <div className="mt-8 flex gap-3">
            {SOCIALS.map(({ Icon, label, href }) => (
              <a key={label} href={href} aria-label={label}
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/50 hover:text-white hover:border-white/30 transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 font-bold mb-5">{col.title}</p>
              <ul className="space-y-3">
                {col.items.map((item) => (
                  <li key={item.label}>
                    <Link to={item.href} className="text-sm text-white/55 hover:text-white transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40 font-light">© {year} {company.fullName || 'Digitize Intl.'}. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs text-white/40 hover:text-white/70 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-xs text-white/40 hover:text-white/70 transition-colors">Terms</Link>
            <p className="text-xs text-white/40 font-light">{company.website || 'www.digitizeintl.com'}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
